import { v4 as uuid } from 'uuid';
import { ActiveMessageConstants } from 'modules/application/detail/attendance/activemessage/ActiveMessageConstants';
export class ActiveMessageDeskSharedService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
        this.commandDestination = `${ActiveMessageConstants.DOMAIN_AUTHORITY_NAME}@${ActiveMessageConstants.DESK_DOMAIN}`;
    }
    async get(filters) {
        let uri = ActiveMessageConstants.URI_GET_MESSAGE_TEMPLATE_PARAMS;
        if (filters) {
            uri = `${uri}?${filters}`;
        }
        return await this.MessagingHubService.processCommand({
            method: 'get',
            to: this.commandDestination,
            uri: uri,
        });
    }
    async save(messageTemplateParams) {
        delete (messageTemplateParams.editingState);
        return await this.MessagingHubService.processCommand({
            method: 'set',
            type: ActiveMessageConstants.MIME_TYPE,
            to: this.commandDestination,
            uri: ActiveMessageConstants.URI_SET_MESSAGE_TEMPLATE_PARAMS,
            resource: messageTemplateParams,
        });
    }
    async getReturnFlow() {
        return await this.MessagingHubService.processCommand({
            method: 'get',
            to: this.commandDestination,
            uri: ActiveMessageConstants.URI_GET_STATES,
        });
    }
    async getIsWhatsAppConnected() {
        const command = {
            id: uuid(),
            to: ActiveMessageConstants.DESK_POSTMASTER,
            method: 'get',
            uri: `${ActiveMessageConstants.WHATSAPP_CONNECTED}`,
        };
        const result = await this.MessagingHubService.processCommand(command);
        return result && result.status.toLowerCase() === 'success'
            && result.resource && result.resource.value
            && result.resource.value.toLowerCase() === 'true';
    }
    async getPendingSettingsValidation() {
        const command = {
            id: uuid(),
            to: ActiveMessageConstants.DESK_POSTMASTER,
            method: 'get',
            uri: `${ActiveMessageConstants.URI_GET_VALIDATE_ACTIVE_MESSAGE}`,
        };
        return await this.MessagingHubService.processCommand(command);
    }
    async getRouterIdValidation(routerId) {
        const command = {
            id: uuid(),
            to: ActiveMessageConstants.DESK_POSTMASTER,
            method: 'get',
            uri: `${ActiveMessageConstants.URI_GET_VALIDATE_ROUTERID}/${routerId}`,
        };
        return await this.MessagingHubService.processCommand(command);
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
ActiveMessageDeskSharedService.$inject = ['MessagingHubService'];
